<template>
  <div
    style="background: url('https://space-tech.sgp1.cdn.digitaloceanspaces.com/smt233/generals/smt223_background.jpg') no-repeat 50% / cover !important; min-height: 100vh; height: auto; padding-bottom: 15rem;""
  >
    <div style="height: 100vh;">
      <div class="login-cont container">
        <div class="d-flex justify-content-center h-100">
          <div class="col-12 px-0 d-flex flex-column">
            <img
              class="mx-auto mb-4"
              src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/buffalo688/buffalo688.webp"
              alt=""
              @click="$router.push('/home')"
              style="height: 6rem"
            />
            <!-- <div class="card border-0 mb-0 auth-card bg-transparent"> -->
            <div
              class="card-body px-2 d-flex mx-0 col-12 mx-auto" style="background-color: rgba(0, 0, 0, .3) !important; border-radius: 1.5rem;"
            >
              <div class="col-12">
                <div class="text-center mb-4">
                  <div
                    class="error text-center py-2"
                    v-if="error"
                  >
                    <span class="mx-auto">
                      {{ $t('auth.fail_message') }}
                    </span>
                  </div>
                </div>
                <form role="form">
                  <small
                    class="text-dark"
                    style="color: rgb(240 97 38 / 1) !important"
                  >{{ errors.name }}</small>
                  <div class="form-group mb-3">
                    <label style="color: white; font-weight: 550; letter-spacing: 0.5px;">{{ $t('auth.username')
                      }}</label>
                    <!-- <div
                      class="input-group input-group-merge input-group-alternative bg-transparent"
                    > -->
                    <input
                      class="form-control pl-2 px-4 custom-input"
                      style="background-color: transparent; color: white; box-shadow: none; border: none; font-size: 1.2rem; border: 2px solid #d6e2f4; border-radius: 1rem;"
                      type="text"
                      v-model="name"
                      @keyup.enter="focusOnPasswordInputBox"
                    />
                    <!-- </div> -->
                  </div>

                  <div class="form-group mb-3 pt-3">
                    <small
                      class="text-dark"
                      style="color: rgb(240 97 38 / 1) !important"
                    >{{ errors.phone }}</small>
                    <div class="form-group mb-3">
                      <label style="color: white; font-weight: 550; letter-spacing: 0.5px;">{{ $t('setting.phone')
                        }}</label>
                      <!-- <div
                          class="input-group input-group-merge input-group-alternative bg-transparent"
                        > -->
                      <input
                        class="form-control pl-2 px-4 custom-input"
                        style="background-color: transparent; color: white; box-shadow: none; border: none; font-size: 1.2rem; border: 2px solid #d6e2f4; border-radius: 1rem;"
                        type="text"
                        v-model="phone"
                        @keyup.enter="focusOnPasswordInputBox"
                      />
                      <!-- </div> -->
                    </div>
                  </div>
                  <small
                    class="text-dark"
                    style="color: rgb(240 97 38 / 1) !important"
                  >{{ errors.password }}</small>
                  <div class="form-group pt-3">
                    <label style="color: white; font-weight: 550; letter-spacing: 0.5px;">{{ $t('auth.password')
                      }}</label>
                    <div
                      class="input-group"
                      style="box-shadow: none !important"
                    >
                      <input
                        class="form-control pl-2 px-4 custom-input"
                        style="background-color: transparent; color: white; box-shadow: none; border: none; font-size: 1.2rem; border: 2px solid #d6e2f4; border-radius: 1rem;"
                        type="password"
                        ref="password"
                        v-model="password"
                        @keyup.enter="loginWithPhone"
                      />
                      <i
                        class="far fa-eye showable-password"
                        v-if="isShowPassword"
                        @click="showablePassword('password')"
                      ></i>
                      <i
                        v-if="!isShowPassword"
                        class="fas fa-eye-slash showable-password"
                        @click="showablePassword('password')"
                      ></i>
                    </div>
                  </div>
                  <small
                    class="text-dark"
                    style="color: rgb(240 97 38 / 1) !important"
                  >{{ errors.confirm_password }}</small>
                  <div class="form-group pt-3">
                    <label style="color: white; font-weight: 550; letter-spacing: 0.5px;">{{ $t('auth.confirm_password')
                      }}</label>
                    <div
                      class="input-group"
                      style="box-shadow: none !important"
                    >
                      <input
                        class="form-control pl-2 px-4 custom-input"
                        style="background-color: transparent; color: white; box-shadow: none; border: none; font-size: 1.2rem; border: 2px solid #d6e2f4; border-radius: 1rem;"
                        type="password"
                        ref="confirm_password"
                        v-model="confirm_password"
                        @keyup.enter="loginWithPhone"
                      />
                      <i
                        class="far fa-eye showable-password"
                        v-if="isShowConfirmPassword"
                        @click="showablePassword('confirm_password')"
                      ></i>
                      <i
                        v-if="!isShowConfirmPassword"
                        class="fas fa-eye-slash showable-password"
                        @click="showablePassword('confirm_password')"
                      ></i>
                    </div>
                    <!-- </div> -->
                  </div>
                  <div class="text-center mt-4">
                    <button
                      type="button"
                      class="btn my-4"
                      style="background: linear-gradient(180deg, #91f27f, #00b302); color: white; border-radius: 1rem; width: 15rem; box-shadow: none; height: 3rem !important; font-size: 1.1rem;"
                      :disabled="isSignin"
                      @click="loginWithPhone()"
                    >
                      <div v-if="!isSignin">
                        {{ $t('auth.sign_up') }}
                      </div>

                      <Loading
                        color="#000000"
                        v-if="isSignin"
                        size="24"
                        class="px-4 py-0"
                      />
                    </button>
                  </div>
                  <!-- <div class="col-12 d-flex my-1">
                    <div
                      class="col-5 p-0 my-auto"
                      style="border-top: 1px solid #ccc; height: 0;"
                    ></div>
                    <div class="my-auto text-white px-3">OR</div>
                    <div
                      class="col-5 p-0 my-auto"
                      style="border-top: 1px solid #ccc; height: 0;"
                    ></div>
                  </div>
                  <div class="text-center mb-3">
                    <button
                      type="button"
                      class="btn my-4"
                      style="background: #C7A241 !important; color: black; border-radius: 1rem; width: 15rem; box-shadow: none;"
                      @click="$router.push('/auth/login')"
                    >
                      <div>
                        {{ $t('auth.login') }}
                      </div>
                    </button>
                  </div> -->
                  <!-- <div class="d-flex justify-content-center">
                      <span style="color: #ffffff; text-decoration: underline;" @click="$router.push('/auth/not-auth-verify')">Forgot Password?</span>
                    </div> -->
                </form>
              </div>
            </div>
            <!-- </div> -->
            <div class="row mt-3">
              <div class="col-4">
                <div
                  class="modal fade"
                  id="forgetPassword"
                  tabindex="-1"
                  role="dialog"
                  aria-labelledby="modal-form"
                  aria-hidden="true"
                >
                  <div
                    class="modal-dialog modal- modal-dialog-centered"
                    role="document"
                  >
                    <div class="modal-content">
                      <div class="modal-body p-5">
                        <b>
                          Please direct contact to customer service -
                          <span class="text-dark">09756477723</span>
                        </b>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { Toast, Loading } from 'vant';
import { mapActions } from 'vuex';

export default {
  components: { Loading },
  data() {
    return {
      name: null,
      phone: null,
      password: null,
      confirm_password: null,
      error: false,
      errors: {},
      isSignin: false,
      isShowPassword: false,
      isShowConfirmPassword: false,
      newUserData: {}
    };
  },
  methods: {
    ...mapActions(['fetchUser']),
    showablePassword(ref) {
      if (ref === 'password') {
        if (this.isShowPassword) {
          this.$refs[ref].type = 'password';
        } else {
          this.$refs[ref].type = 'text';
        }
        this.isShowPassword = !this.isShowPassword;
      } else {
        if (this.isShowConfirmPassword) {
          this.$refs[ref].type = 'password';
        } else {
          this.$refs[ref].type = 'text';
        }
        this.isShowConfirmPassword = !this.isShowConfirmPassword
      }
    },

    copyToClipboard(text) {
      if (navigator.clipboard && window.isSecureContext) {
        // Modern secure clipboard API (Safari 13+, iOS 14+)
        navigator.clipboard.writeText(text).then(() => {
          // eslint-disable-next-line no-alert
          alert('Copied successfully!');
        }).catch((err) => {
          // eslint-disable-next-line no-alert
          alert('Clipboard copy failed:', err);
        });
      } else {
        // Fallback for older Safari/iOS: use a hidden textarea
        const textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.style.position = 'fixed'; // prevent scroll jump
        textarea.style.opacity = 0;
        document.body.appendChild(textarea);
        textarea.focus();
        textarea.select();
        try {
          document.execCommand('copy');
          // eslint-disable-next-line no-alert
          alert('Copied using fallback!');
        } catch (err) {
          // eslint-disable-next-line no-alert
          alert('Fallback copy failed:', err);
        }
        document.body.removeChild(textarea);
      }
    },

    focusOnPasswordInputBox() {
      this.$refs.password.focus();
    },
    /**
     * login with phone
     */
    async loginWithPhone() {
      this.isSignin = true;
      this.errors = {};
      console.log('1')
      if (!this.name) {
        this.errors.name =
          this.$store.state.language === 'en'
            ? 'Required User Name'
            : 'User name လိုအပ်ပါသည်။';
        this.isSignin = false;
        return false;
      }
      if (!this.phone) {
        this.errors.phone =
          this.$store.state.language === 'en'
            ? 'Required Phone'
            : 'Phone လိုအပ်ပါသည်။';
        this.isSignin = false;
        return false;
      }
      if (!this.password) {
        this.errors.password =
          this.$store.state.language === 'en'
            ? 'Required Password'
            : 'Password လိုအပ်ပါသည်။';
        this.isSignin = false;
        return false;
      }
      if (!this.confirm_password) {
        this.errors.confirm_password =
          this.$store.state.language === 'en'
            ? 'Required Confirm Password'
            : 'Confirm Password လိုအပ်ပါသည်။';
        this.isSignin = false;
        return false;
      }
      if (this.confirm_password !== this.password) {
        this.errors.confirm_password =
          this.$store.state.language === 'en'
            ? 'Password not match!'
            : 'Password not match!';
        this.isSignin = false;
        return false;
      }

      try {
        const res = await this.axios.post(
          '/auth/register',
          {
            user_name: this.name,
            phone: this.phone,
            password: this.password,
            confirmPassword: this.confirm_password,
            roles: 'normal',
            referralCode: localStorage.getItem('referralCode'),
            // code: localStorage.getItem('fcm'),
          },
        );
        this.newUserData = res.data.data;

        localStorage.setItem('username', this.newUserData.name);
        localStorage.setItem('password', this.password);
        localStorage.setItem('phone', this.phone);
        localStorage.setItem('token', res.data.token);
        localStorage.setItem('firstTimeRegister', true);

        await this.fetchUser();
        this.$router.push('/auth/login');

        Toast.success(
          this.$store.state.language === 'en'
            ? 'Success!'
            : 'Success!'
        );
      } catch (err) {
        this.error = true;
      }
      this.isSignin = false;
      return true;
    },
  },
  async mounted() {
    if (this.$route.query.code) {
      localStorage.setItem('referralCode', this.$route.query.code);
    }
    const authUser = await this.fetchUser();
    if (authUser)
      this.$router.push('/home');
    // const userName = localStorage.getItem('username');
    // const password = localStorage.getItem('password');
    // if (userName && password) {
    //   this.name = userName;
    //   this.password = password;
    // }
  },
};
</script>

<style scoped>
.custom-input:active, .custom-input:focus {
  border: 1px solid #d6e2f4 !important;
}

.login-cont {
  padding-top: 3rem;
}

.showable-password {
  position: absolute;
  right: 15px;
  top: 15px;
  cursor: pointer;
  z-index: 1000;
  color: #EBAB0B;
}

.new-account-text {
  cursor: pointer;
}

.error {
  margin-bottom: 13px;
  /* height: 40px; */
  display: flex;
  align-items: center;
  color: white;
  border-radius: .5rem;
  padding: 0px 15px;
  background: #000000 !important;
  border: 1px solid rgb(240 97 38 / 1) !important;
  box-shadow: none !important;
  /* font-weight: bold; */
}

.auth-card {
  background: #eeecec;
  /* color: black */
}
</style>
